export default "__VITE_ASSET__B7Qq6P1I__"